import {
  AppBar,
  Box,
  Button,
  Checkbox,

  Grid,

  List, ListItem,
  ListItemIcon,
  ListItemText, Modal, Toolbar,
  Typography
} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
// import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilledIcon';
import SearchIcon from '@material-ui/icons/Search';
import { Autocomplete } from '@material-ui/lab';
import algoliasearch from 'algoliasearch';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import EnquiryService from 'src/services/enquiry/enquiry.service';
import { algoliaIndex } from 'src/utils/algoliadata';
import { history } from 'src/utils/utils';
import doc from "../../image/doc_icon_l.png";
import jpg from "../../image/jpg_icon_l.png";
import mov from "../../image/mov_icon_l.png";
import mpg from "../../image/mpg_icon_l.png";
import pdf from "../../image/pdf_icon_l.png";
import ppt from "../../image/ppt_icon_l.png";
import requestly_logo from "../../image/requestly_logo_white.png";
import xlss from "../../image/xls_icon_l.png";
import './css/product.scss';
const searchClient = algoliasearch('JE3UA8IZ0R', 'dfb17da784818795fc420e50bfb6cfdb');
const searchIndex = searchClient.initIndex(algoliaIndex);

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    flexGrow: 1,
    fontFamily: '"Spartan", sans-serif!important'
    // background: `url(${wave})`,
    // backgroundSize: 'cover',
    // backgroundColor: '#64829a59',
    // backgroundBlendMode: 'screen'
  },
  videoStyle: {
    objectFit: 'cover',
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: -1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  headerStyle: {
    background: '#F2564C'
  },
  title: {
    cursor: 'pointer',
    color: '#fff',
    fontSize: '3rem',
    fontWeight: 600,
    padding: '0.2em 0',
    fontFamily: '"Spartan", sans-serif!important'
  },
  productName: {
    color: '#000000',
    padding: '0.4em 0',
    fontSize: '2rem',
    fontFamily: '"Spartan", sans-serif!important',
    fontWeight: 700,
    display: 'block',
    verticalAlign: 'middle',
    position: 'relative'
  },
  iconSize: {
    fontSize: "2.1rem",
    color: "#707070"
  },
  companyName: {
    fontSize: '10px',
    display: 'inherit',
    color: 'white',
    textAlign: 'right',
    backgroundColor: '#7c8591',
    fontFamily: '"Spartan", sans-serif!important',
    letterSpacing: '.2rem',
    padding: '0.5em 1.3em',
    borderRadius: '0 2px 2px 0',
    position: 'absolute',
    top: '2.5rem',
    right: 0
  },
  getStartedButtonStyle: {
    background: '#F2564C',
    color: '#fff'
  },
  rightNav: {
    width: '100%',
    paddingLeft: '1rem'
  },
  rightNavText: {
    color: '#000',
    fontFamily: '"Spartan", sans-serif!important'
  },
  navList: {
    listStyle: 'none',
    padding: '1em 0,',
    margin: 0,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  navListItem: {
    padding: '0.5em 0',
    marginLeft: '3em',
    color: 'black',
    position: 'relative',
    cursor: 'pointer',
    '&::after': {
      content: '""',
      display: 'block',
      height: '3px',
      width: 0,
      backgroundColor: '#F2564C',
      position: 'absolute',
      bottom: 0,
      transition: '0.2s'
    }
  },
  searchInputStyle: {
    width: '45%',
    color: '#000',
    height: '2.5rem',
    outlineWidth: 0,
    fontWeight: 600,
    borderRadius: '2rem',
    border: '2px solid #fff',
    paddingLeft: '2%',
    paddingRight: '5.5%',
    textOverflow: 'ellipsis',
    fontSize: '.8rem',
    background: '#white',
    marginLeft: "78px"
  },
  searchWrapper: {
    width: '50vW',
    position: 'absolute',
    top: '40%'
  },
  searchBarWrap: {
    textAlign: 'left'
  },
  paper: {
    textAlign: 'center',
    padding: '2px 5px 2px 5px',
    background: '#000',
    color: '#fff'
  },
  footerWrapper: {
    position: 'absolute',
    bottom: '2rem',
    width: '70vW',
    textAlign: 'center',
    justifyContent: 'center'
  },
  iconStyle: {
    fontSize: '2.5rem',
    verticalAlign: 'middle'
  },
  footerText: {
    background: 'transparent',
    border: 0,
    boxShadow: 'unset',
    fontSize: '3rem',
    color: '#fff',
    fontWeight: 200
  },
  paperTextOur: {
    background: '#f2564c'
  },
  paperText: {
    verticalAlign: 'middle',
    display: 'inline'
  },
  autoCompleteTextStyle: {
    color: '#000',
    fontSize: '.8rem'
  },
  sliderBg: {
    background: 'url(/static/media/s1.3a39b803.png)',
    backgroundSize: 'cover',
    padding: '0px 0 0 10px',
    display: 'block',
    backgroundRepeat: 'no-repeat',
    // height: '15rem',
    // minHeight: '15rem',
    backgroundPosition: 'center',
    overflow: 'hidden'
  },
  logoSecCover: {
    padding: 0,
    // display:"flex"
    // paddingTop: '15px'
  },
  companyInfoSec: {
    display: 'block',
    float: 'left',
    position: 'absolute',
    bottom: -9,
    marginBottom: '.2rem'
  },
  companyInfoLink: {
    padding: '.8rem',
    background: '#f2564c',
    color: '#fff',
    borderRadius: '.5rem .5rem 0rem .0rem',
    '&:hover': {
      color: '#fff'
    }
  },
  overviewStyle: {
    paddingTop: '0rem'
  },
  categoryStyle: {
    fontSize: '.7rem',
    padding: '1rem',
    paddingBottom: 0,
    paddingLeft: '2rem'
  },
  overviewTextStyleDownload: {
    display: "block",
    // paddingLeft: "19px",
    fontSize: ".7rem"
  },
  overviewTextStyleDownloadNoImage: {
    display: "block",
    // paddingLeft: "19px",
    paddingTop: "90px",
    fontSize: ".7rem"
  },
  overviewTextStyle: {
    fontSize: '.7rem',
    // dis[lay:
  },
  companyIntroBlock: {
    position: 'absolute',
    top: '-34px',
    left: '19px',
    display: 'block',
    background: 'transparent',
    padding: '0px 17px'
  },
  boxBorder: {
    position: 'relative',
    bottom: '0px',
    backgroundColor: 'red'
  },
  boxborder: {
    border: '1px solid gainsboro',
    minHeight: "80px",
    margin: '8px',
    padding: '0px 10px 5px 15px',
    borderRadius: '10px'
  },
  boxborderDownload: {
    border: '1px solid gainsboro',
    margin: '8px',
    padding: '0px 10px 5px 15px',
    height: "100%",
    borderRadius: '10px'
  },
  introText: {
    width: '6.5em',
    fontSize: '20px !important',
    marginTop: '-10px',
    marginLeft: '24px',
    background: '#f4f6f8',
  },
  introTextKeywords: {
    width: '6em',
    fontSize: '20px !important',
    marginTop: '-10px',
    marginLeft: '24px',
    background: '#f4f6f8',
  },
  introTextKeywordsCustomerRoles: {
    width: '8.5em',
    fontSize: '20px !important',
    marginTop: '-10px',
    marginLeft: '24px',
    background: '#f4f6f8',
  },
  introTextKeywordsCustomer: {
    width: '11em',
    fontSize: '20px !important',
    marginTop: '-10px',
    marginLeft: '24px',
    background: '#f4f6f8',
  },
  chipsStyle: {
    margin: '.5rem',
    background: '#e0e0e0',
    fontSize: '12px'
  },
  boxborder4: {
    border: '1px solid gainsboro',
    margin: '8px',
    borderRadius: '10px',
    minHeight: "92px"
  },
  detailsText: {
    width: '5rem',
    background: '#f4f6f8',
    marginTop: '-10px',
    marginLeft: '25px',
    fontSize: '20px !important'
  },
  CompetitorText: {
    width: '10rem',
    background: '#f4f6f8',
    marginTop: '-10px',
    marginLeft: '25px',
    fontSize: '20px !important'
  },
  detailsTextDetail: {
    padding: '0px 10px 10px 10px',
    margin: 0,
    fontSize: '.7rem'
  },
  noPadding: {
    paddingLeft: "28px",
    marginTop: "45px"
  },
  autoCompletePopperProduct: {
    width: '30vW!important',
    maxWidth: '30vW!important',
    top: '3px !important',
    left: '-15%!important'
  },
  playIcon: {
    position: 'absolute',
    top: '32%',
    left: '49%',
    fontSize: '4rem',
    cursor: 'pointer'
  },
  dialogTitle: {
    padding: 0,
    textAlign: 'right'
  },
  engageNewRelicText: {
    height: '44px',
    fontFamily: 'Spartan',
    fontSize: '20px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.2',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#ffffff',
  },
  engageNewRelicBtn: {
    width: '180px',
    height: '80px',
    margin: '50px 0 113px 195px',
    padding: '16px 28px 7px',
    boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.16)',
    border: 'solid 1px #dddddd',
    backgroundColor: '#f2564c',
    position: 'fixed',
    borderRadius: '10px 0px 0px 10px',
    zIndex: 9999,
  },
  // videoGrid: {
  //   position: "relative",
  //   marginBottom: "45px"
  // },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperModal: {
    width: '656px',
    height: '507px',
    borderRadius: '10px',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    border: 'solid 1px #dddddd',
    backgroundColor: '#ffffff',
    padding: '50px',
  },
  letsGoBtn: {
    padding: '14px 29px 9px',
    borderRadius: '5px',
    backgroundColor: '#f2564c',
    color: '#fff',
  },
  // gridWidth: {
  //   width: "95%",
  // },
  downloadSection: {
    float: "left",
    margin: "10px",
    padding: "10px 3px",
    // maxWidth: "144px",
  },
  loginButton: {
    position: "absolute",
    left: "88%",
    top: "24%",
    cursor: "pointer"
  },
  fileHover: {

  }
}));

const ProductPage = (props) => {
  const enquiryService = new EnquiryService();
  const [querySearch, setQuerySearch] = useState('');
  const [value, setValue] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let isMounted = true;
  // const handleChange = (event, newValue) => {
  //     setValue(newValue);
  // };
  const [options, setOptions] = useState([]);
  const [wouldLikeSelectedOption, setWouldLikeSelectedOption] = useState([]);
  const [product, setProduct] = useState({});
  const [popupStep, setPopupStep] = useState(0);
  const [FileFullName, setFileFullName] = useState(false);
  const [fileId, setFileId] = useState();

  const wouldLikeOptions = [{
    value: 1,
    label: '15min discovery meeting'
  }, {
    value: 2,
    label: 'Product demo'
  }, {
    value: 3,
    label: 'start a Proof of Value/Proof of Concept'
  }, {
    value: 4,
    label: 'Access to technical requirements template'
  }, {
    value: 5,
    label: 'Request of Information'
  }, {
    value: 6,
    label: 'Formal Request for Proposal'
  }]
  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            {children}
          </Box>
        )}
      </div>
    );
  };
  useEffect(() => {
    const abortController = new AbortController();
    // eslint-disable-next-line react/prop-types
    // console.log(props.location.search, "props.location.search...")
    const query = queryString.parse(props.location.search);

    // setQuerySearch(query.search);
    async function fetchData() {
      // You can await here
      await searchIndex.getObject(query.search)
        .then(async (res) => {
          // const productDetail = hits[0];
          if (res && res !== undefined) {
            setProduct(res)
            setQuerySearch(res.product);
          }
        }).catch((err) => {
          console.log(err, "err")
        })
      // ...
    }
    fetchData();
    return () => abortController.abort();
  }, [props]);

  const isUrl = (s) => {
    var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
    return regexp.test(s);
  }

  const goToCompanyPage = async (val) => {
    console.log(val, "valCompany...")
    isMounted = false;
    if (val && val.product) {
      const query = {
        search: val.objectID,
        //category: [].join(','),
        //subCategory: [].join(','),
        //allKeywords: [].join(','),
        // company: [].join(','),
      };
      console.log(query, "query");
      await history.push(`/product/${(val.product.toLowerCase()).replace(/\s+/g, "-")}?${queryString.stringify(query)}`, {
        data: {
          params: val
        }
      });
    } else if (val && val.category) {
      const query = {
        search: val.category,
        category: [`category:${val.category}`].join(','),
        subCategory: [].join(','),
        allKeywords: [].join(','),
        company: [].join(','),
        page: 0
      };
      await history.push(`/search?${queryString.stringify(query)}`, {
        data: {
          params: val
        }
      });
    } else if (val && val.subCategory) {
      const query = {
        search: val.subCategory,
        category: [].join(','),
        allKeywords: [].join(','),
        company: [].join(','),
        subCategory: [`subCategory:${val.subCategory}`].join(','),
        page: 0
      };
      await history.push(`/search?${queryString.stringify(query)}`, {
        data: {
          params: val
        }
      });
    } else {
      const query = {
        search: val,
        category: [].join(','),
        subCategory: [].join(','),
        allKeywords: [].join(','),
        company: [].join(','),
        page: 0
      };
      await history.push(`/search?${queryString.stringify(query)}`, {
        data: {
          params: val
        }
      });
    }
  };

  useEffect(() => {
  }, [isMounted, isDialogOpen]);

  const searchFromAlgolia = async (val) => {
    const abortController = new AbortController();
    if (isMounted) {
      // setSearchInputValue(val);
      if (val.length < 4) {
        return;
      }
      await searchIndex.search(val, {
        attributesToRetrieve: ['product', 'category', 'subCategory'],
        facets: ['category', 'subCategory'],
        hitsPerPage: 8
      }).then(async ({ hits, facets }) => {
        // console.log(res, "res...")
        hits = hits.slice(0, 4);
        const products = hits;
        const { category, subCategory } = facets;
        // console.log(facets, "facets")
        // console.log(hits, "hits")
        // console.log(category[0], "category")
        if (category) {
          // eslint-disable-next-line no-unused-expressions
          Object.keys(category)[0] ? products.push({
            category: Object.keys(category)[0]
          }) : '';
          // eslint-disable-next-line no-unused-expressions
          Object.keys(category)[1] ? products.push({
            category: Object.keys(category)[1]
          }) : '';
        }
        if (subCategory) {
          // eslint-disable-next-line no-unused-expressions
          Object.keys(subCategory)[0] ? products.push({
            subCategory: Object.keys(subCategory)[0]
          }) : '';
          // eslint-disable-next-line no-unused-expressions
          Object.keys(subCategory)[1] ? products.push({
            subCategory: Object.keys(subCategory)[1]
          }) : '';
        }
        setOptions(products);
      });
    }
    // eslint-disable-next-line consistent-return
    return () => abortController.abort();
  };
  const classes = useStyles();
  // const flexContainer = {
  //   display: 'flex',
  //   flexDirection: 'row',
  //   padding: 0
  // };

  const userName = localStorage.getItem('user');

  const goToHome = () => history.push('/');

  const handlePlayIcon = () => {
    setIsDialogOpen(true)
  }

  const toggleHover = (e) => {
    console.log("in", e);
    setFileId(e)

    setFileFullName(!FileFullName)

  }

  const _submitEnquiry = () => {
    const enquiryObj = {
      companyId: localStorage.getItem('companyId'),
      enquiries: wouldLikeSelectedOption
    };
    enquiryService.submitEnquiry(enquiryObj).then((res) => {
      localStorage.removeItem('isPopupOpen');
    })
  };
  const isPopupOpen = localStorage.getItem('isPopupOpen');
  useEffect(() => {
    if (isPopupOpen && isPopupOpen !== '') {
      setPopupStep(1);
    }
  }, [isPopupOpen]);

  product && product.videoLinks && product.videoLinks.map((value, key) => {
    if (value.length > 0) {
      product.videoLinks[0] = value.replace('watch?v=', 'embed/')
    }
  })


  console.log(product, "product")

  return (
    <div className={classes.root}>
      <AppBar className={classes.headerStyle} position="static">
        <Toolbar>
          <img onClick={() => goToHome()} src={requestly_logo} style={{ height: "46px", cursor: "pointer" }} />
          <div className={classes.rightNav}>
            <nav style={{ position: "relative" }}>
              <div className={`${classes.searchBarWrap} searchBarProduct`}>
                <Autocomplete
                  id="custom-input-demo"
                  value={querySearch}
                  freeSolo
                  classes={{
                    popper: classes.autoCompletePopperProduct
                  }}
                  getOptionLabel={(option) => (typeof option === 'string' ? `${querySearch}` : `${querySearch}`)}
                  filterOptions={(x) => x}
                  options={options}
                  disableClearable
                  onChange={async (event, newValue) => {
                    goToCompanyPage(newValue);
                  }}
                  onInputChange={(e, val) => {
                    searchFromAlgolia(val);
                  }}
                  renderInput={(params) => (
                    <div ref={params.InputProps.ref}>
                      <input
                        {...params.inputProps}
                        className={classes.searchInputStyle}
                        type="search"
                        placeholder="Search company, software name, category, service, CEO..."
                      />
                      <span className="material-icons face">
                        <SearchIcon className={classes.iconSize} />
                      </span>
                    </div>
                  )}
                  renderOption={(option) => {
                    return (
                      <Grid
                        container
                        alignItems="center"
                        // style={{ marginLeft: "100px" }}
                        onClick={async () => {
                          isMounted = false;
                        }}
                      >
                        <Grid
                          container
                          alignItems="center"
                          onClick={async () => {
                            isMounted = false;
                          }}
                        >
                          <Typography variant="body2" className={classes.autoCompleteTextStyle}>
                            {option && option.product
                              ? `Product: ${option.product}`
                              : `Category: ${option.category ? option.category : option.subCategory
                              }`}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  }}
                />
                {userName && userName !== '' ? (
                  <div
                    className={classes.loginButton}
                    onClick={() => {
                      history.push('/app/dashboard');
                    }}
                  >
                    Login
                  </div>
                ) : (
                  <div
                    className={classes.loginButton}
                    onClick={() => {
                      history.push('/auth/login');
                    }}
                  >
                    Login
                  </div>
                )}
              </div>
            </nav>
          </div>
        </Toolbar>
      </AppBar>

      {product.videoLinks && Array.isArray(product.videoLinks) && product.videoLinks.length !== 0 && product.videoLinks[0] !== "" && isUrl(product.videoLinks[0]) &&
        <Grid className={classes.videoGrid}>
          <iframe width="100%" height="315" title="video" onClick={() => { console.log("working") }} src={product.videoLinks[0]} allowFullScreen />
        </Grid>
      }




      {  /*<Grid container display="flex" justify="flex-end" className={classes.gridWidth} >
        <Grid
          xl={2}
          lg={2}
          md={2}
          sm={2}
          xs={2}
          className={classes.engageNewRelicBtn}
          onClick={() => {
            if (localStorage.getItem('userId') && localStorage.getItem('userId') !== '') {
              setPopupStep(1);
            } else {
              localStorage.setItem('lastPathname', props.location.pathname);
              localStorage.setItem('searchParams', props.location.search);
              localStorage.setItem('isPopupOpen', true);
              props.history.push('/auth/login');
            }

          }}
        >
          <Typography
            className={classes.engageNewRelicText}
          >
            Engage New Relic
          </Typography>
        </Grid>
      </Grid>*/
      }
      <div className="container-fluid">
        <div className="row">
          <div className={`col-sm-12 col-md-12 ${classes.noPadding}`}>
            <div className={`${classes.sliderBg} sliderSec`} id="top-margin-c">
              <div className={classes.logoSecCover}>
                <div style={{}}>
                  {

                    product.logo && product.logo !== ''
                    &&
                    (product.logo !== "https://requestly-media-public.s3.eu-west-2.amazonaws.com/company_logos/")
                    && (<img
                      style={{ display: 'inline', height: "80px" }}
                      src={product.logo}
                      className="img-responsive"
                      alt="company"
                    />
                    )
                  }

                  <Typography variant="h3" className={classes.productName}>
                    {product.product}
                  </Typography>
                  {/* <div className={classes.companyName}>{product.company}</div> */}
                </div>
              </div>
              {/* {
                product.videoLinks && Array.isArray(product.videoLinks) && product.videoLinks.length !== 0 ? (
                  <PlayCircleFilledIcon onClick={() => handlePlayIcon()} className={classes.playIcon} />
                ) : null
              } */}
              {/* {

                <PlayCircleFilledIcon onClick={() => handlePlayIcon()} className={classes.playIcon} />

              } */}

              {/* <div className={classes.companyInfoSec}>
                <ul>
                  <li style={{ listStyle: 'none' }}>
                    <a href="#" className={classes.companyInfoLink}>
                      Product Info
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
        <div className={classes.categoryStyle}>
          <a style={{ color: 'blue', cursor: 'pointer' }} onClick={() => goToCompanyPage({ category: product.category })}>{product.category}</a> {
            product.subCategory !== '' ? (
              <span>&emsp; &#8594; &emsp; <a style={{ color: 'blue', cursor: 'pointer' }} onClick={() => goToCompanyPage({ subCategory: product.subCategory })}>{product.subCategory}</a></span>
            ) : null
          }
        </div>


        <div className={`row ${classes.overviewStyle}`}>
          <TabPanel style={{ width: '100%' }} value={value} index={0}>
            <div>
              <Grid container>
                <Grid item xs={12} sm={10} md={10} lg={10}>
                  <Box className={classes.boxborder}>
                    <h1 className={classes.introText}>Introduction</h1>
                    <span className={classes.overviewTextStyle}>
                      {product.description}
                    </span>
                  </Box>
                </Grid>



                <Grid item xs={12} sm={2} md={2} lg={2}>
                  <Box className={classes.boxborder4}>
                    <h1 className={classes.detailsText}> Details</h1>
                    {
                      product.clean_url ? (<p className={classes.detailsTextDetail}> <a href={product.clean_url.includes('http') ? product.clean_url : `http://${product.clean_url}`} target="_blank" rel="noreferrer">{product.clean_url}</a> </p>) : ''
                    }
                    {
                      product.noEmployees ? (<p className={classes.detailsTextDetail}> Employees - {product.noEmployees} </p>) : ''
                    }
                    {
                      product.yearFounded ? (<p className={classes.detailsTextDetail}> Founded - {product.yearFounded} </p>) : ''
                    }
                    {
                      product.annualRevenue ? (<p className={classes.detailsTextDetail}> Revenue - {product.annualRevenue} </p>) : ''
                    }
                    {
                      product.hqLocation ? (<p className={classes.detailsTextDetail}> Location - {product.hqLocation} </p>) : ''
                    }
                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={5} lg={10} style={{ marginBottom: "37px" }}>
                  <Box className={classes.boxborderDownload}>
                    <h1 className={classes.introTextKeywords}>Downloads</h1>

                    {
                      product && product.files ? product.files.map((val, index) => {
                        if (val) {
                          return (
                            <>
                              {val.name.split('.').pop() === "pdf" &&
                                <Grid className={classes.downloadSection}>
                                  {/* <PictureAsPdfIcon style={{ height: "50px", width: "100px", marginTop: "-10px" }} /> */}
                                  {/* <img src={pdf} style={{ marginLeft: "19%" }} /> */}
                                  <img src={pdf} />
                                  <span className={classes.overviewTextStyleDownload}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>

                                </Grid>
                              }

                              {val.name.split('.').pop() === "xlsx" &&
                                <Grid className={classes.downloadSection}>
                                  <img src={xlss} />
                                  <span className={classes.overviewTextStyleDownload}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)} >{val.name}</a>
                                    }
                                  </span>

                                </Grid>
                              }

                              {val.name.split('.').pop() === "jpg" &&
                                <Grid className={classes.downloadSection}>
                                  <img src={jpg} />
                                  <span className={classes.overviewTextStyleDownload}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>

                                </Grid>
                              }

                              {val.name.split('.').pop() === "mov" &&
                                <Grid className={classes.downloadSection}>
                                  <img src={mov} />
                                  <span className={classes.overviewTextStyleDownload}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>

                                </Grid>
                              }

                              {val.name.split('.').pop() === "pptx" &&
                                <Grid className={classes.downloadSection}>
                                  <img src={ppt} />
                                  <span className={classes.overviewTextStyleDownload}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>

                                </Grid>
                              }

                              {val.name.split('.').pop() === "ppt" &&
                                <>
                                  <img src={ppt} />
                                  <Grid className={classes.downloadSection}>
                                    <span className={classes.overviewTextStyleDownload}>
                                      {val.name.length > 12 && !FileFullName ||
                                        (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                        <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                      }
                                    </span>

                                  </Grid>
                                </>
                              }

                              {val.name.split('.').pop() === "mpg" &&
                                <Grid className={classes.downloadSection}>
                                  <img src={mpg} />
                                  <span className={classes.overviewTextStyleDownload}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>

                                </Grid>
                              }

                              {val.name.split('.').pop() === "doc" &&
                                <Grid className={classes.downloadSection}>
                                  <img src={doc} />
                                  <span className={classes.overviewTextStyleDownload}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>
                                </Grid>
                              }

                              {val.name.split('.').pop() === "docx" &&
                                <Grid className={classes.downloadSection}>
                                  <img src={doc} />
                                  <span className={classes.overviewTextStyleDownload}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>
                                </Grid>
                              }

                              {val.name.split('.').pop() === "png" &&
                                <Grid className={classes.downloadSection}>
                                  {/* <img src={doc} style={{ height: "39px", width: "55px", marginLeft: "19%" }} /> */}
                                  <span className={classes.overviewTextStyleDownloadNoImage}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>
                                </Grid>
                              }

                              {val.name.split('.').pop() === "csv" &&
                                <Grid className={classes.downloadSection}>
                                  {/* <img src={doc} style={{ height: "39px", width: "55px", marginLeft: "19%" }} /> */}
                                  <span className={classes.overviewTextStyleDownloadNoImage}>
                                    {val.name.length > 12 && !FileFullName ||
                                      (index !== fileId && val.name.length > 12) ? <a className={classes.fileHover} href={val.location} onMouseEnter={() => toggleHover(index)} >{`${val.name.substring(0, 12)}...`}</a> :
                                      <a href={val.location} onMouseEnter={(e) => toggleHover(e)} onMouseLeave={() => toggleHover(index)}>{val.name}</a>
                                    }
                                  </span>
                                </Grid>
                              }




                            </>
                          )
                        }
                        return null;
                      }) : ""
                    }
                    {product && product.files && product.files !== null && product.files.length === 0 && <p>No Data Provided</p>}

                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={2} lg={2}>
                  <Box className={classes.boxborder4}>
                    <h1 className={classes.CompetitorText}> Competitors</h1>
                    {
                      product && product.competitiors ? product.competitiors.map((val) => {
                        if (val) {
                          return (
                            <Chip
                              key={val}
                              className={classes.chipsStyle}
                              label={val}
                              clickable
                              onClick={() => goToCompanyPage(val)}
                            />
                          )
                        }
                        return null;
                      }) : ""
                    }
                    {product && product.competitiors && product.competitiors !== null && product.competitiors.length === 0 && <p style={{ fontSize: "0.7rem", paddingLeft: "5%" }}>No Data Provided</p>}
                  </Box>
                </Grid>


                <Grid item xs={12} sm={2} md={5} lg={5} style={{ marginBottom: "37px" }}>
                  <Box className={classes.boxborder}>
                    <h1 className={classes.introTextKeywords}>Keywords</h1>
                    <span className={classes.overviewTextStyle}>
                      {
                        product && product.allKeywords ? product.allKeywords.map((val) => {
                          if (val) {
                            return (
                              <Chip
                                key={val}
                                className={classes.chipsStyle}
                                label={val}
                                clickable
                                onClick={() => goToCompanyPage(val)}
                              />
                            )
                          }
                          return null;
                        }) : ""
                      }
                      {product && product.allKeywords && product.allKeywords !== null && product.allKeywords.length === 0 && <p>No Data Provided</p>}
                    </span>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={5} lg={5} style={{ marginBottom: "37px" }}>
                  <Box className={classes.boxborder}>
                    <h1 className={classes.introTextKeywordsCustomer}>Notable Customer</h1>
                    <span className={classes.overviewTextStyle}>
                      {
                        product && product.notableCustomer ? product.notableCustomer.map((val) => {
                          if (val) {
                            return (
                              <Chip
                                key={val}
                                className={classes.chipsStyle}
                                label={val}
                                clickable
                                onClick={() => goToCompanyPage(val)}
                              />
                            )
                          }

                        }) : ""
                      }
                      {product && product.notableCustomer && product.notableCustomer !== null && product.notableCustomer.length === 0 && <p>No Data Provided</p>}
                    </span>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={5} lg={10} style={{ marginTop: "37px" }} style={{ marginBottom: "37px" }}>
                  <Box className={classes.boxborder}>
                    <h1 className={classes.introTextKeywordsCustomerRoles}>Target Persona</h1>
                    <span className={classes.overviewTextStyle}>
                      {
                        product && product.targetPersona ? product.targetPersona.map((val) => {
                          if (val) {
                            return (
                              <Chip
                                key={val}
                                className={classes.chipsStyle}
                                label={val}
                                clickable
                                onClick={() => goToCompanyPage(val)}
                              />
                            )
                          }
                          return null;
                        }) : ""
                      }
                      {product && product.targetPersona && product.targetPersona !== null && product.targetPersona.length === 0 && <p>No Data Provided</p>}
                    </span>
                  </Box>
                </Grid>

              </Grid>
            </div>
          </TabPanel>
        </div>
      </div>
      {popupStep === 1 ? (
        <Modal
          open={true}
          className={classes.modal}
          onClose={() => {
            localStorage.removeItem('isPopupOpen');
            setPopupStep(0)
          }}
        >
          <div className={classes.paperModal}>
            <Typography variant="h1" style={{ color: '#707070' }}>
              I would like a
            </Typography>
            <div>
              <List className={classes.root}>
                {wouldLikeOptions.map((datum) => {
                  const labelId = `checkbox-list-label-${datum.value}`;

                  return (
                    <ListItem key={datum.value} role={undefined} dense button onClick={() => {
                      const index = wouldLikeSelectedOption.findIndex(item => item === datum.value);
                      if (index !== -1) {
                        wouldLikeSelectedOption.splice(index, 1);
                      } else {
                        wouldLikeSelectedOption.push(datum.value);
                      }
                      setWouldLikeSelectedOption([...wouldLikeSelectedOption]);
                    }}>
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={wouldLikeSelectedOption.findIndex(item => item === datum.value) !== -1}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </ListItemIcon>
                      <ListItemText id={labelId} primary={datum.label} />
                    </ListItem>
                  );
                })}
              </List>
            </div>
            <Box display="flex" justifyContent="flex-end">
              <Button
                className={classes.letsGoBtn}
                disabled={!!(wouldLikeSelectedOption.length === 0)}
                onClick={() => {
                  _submitEnquiry();
                }}
              >
                Lets GO!
              </Button>
            </Box>
          </div>
        </Modal>
      ) : null}
    </div>
  );
};

export default ProductPage;
